import { render, staticRenderFns } from "./OneYearPromotionFlow.vue?vue&type=template&id=14d0ce42&scoped=true"
import script from "./OneYearPromotionFlow.vue?vue&type=script&lang=js"
export * from "./OneYearPromotionFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d0ce42",
  null
  
)

export default component.exports